import * as React from 'react';
import useAuth from '../AuthContext/useAuth';
import LoginLayout from './LoginLayout';
import MainLayout from './MainLayout';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated === true) {
    return <MainLayout />;
  }

  return <LoginLayout loading={isAuthenticated === null} />;
};

export default AppContent;
